import { apiClient } from '@isocel/front-common';

import { MiscFlowTypesResponse, MiscFlowType, PackagingFlowDirection } from './types';

// Map from PackagingFlowDirection enum to movement name/label
const flowDirectionToMovement: Record<number, MiscFlowType> = {
    [PackagingFlowDirection.Purchase]: { name: 'Purchase', label: "Achat d'emballages" },
    [PackagingFlowDirection.Sale]: { name: 'Sale', label: "Vente d'emballages" },
    [PackagingFlowDirection.Destruction]: { name: 'Destruction', label: 'Destruction de palettes' },
    [PackagingFlowDirection.ShipmentForRepair]: {
        name: 'ShipmentToRepair',
        label: 'Expédition en réparation des emballages',
    },
    [PackagingFlowDirection.ReceptionFromRepair]: {
        name: 'ReceptionToRepair',
        label: 'Réception des emballages réparés',
    },
    [PackagingFlowDirection.Transfer]: { name: 'Transfer', label: "Transfert d'une entité à une autre" },
    [PackagingFlowDirection.Increase]: { name: 'Increase', label: 'Ajustement interne positif' },
    [PackagingFlowDirection.Decrease]: { name: 'Decrease', label: 'Ajustement interne négatif' },
    [PackagingFlowDirection.ReturnToProvider]: { name: 'Return', label: "Rendu d'emballages au prestataire" },
    [PackagingFlowDirection.ReceiptFromStoreExchange]: {
        name: 'ReceiptFromStoreExchange',
        label: "Réception d'un transfert magasin",
    },
};

export const fetchMiscFlowTypes = async (): Promise<MiscFlowTypesResponse> => {
    console.log('fetchMiscFlowTypes called - about to make API request');
    try {
        const { data } = await apiClient().get('/packagingFlows/miscFlowTypes');
        console.log('miscFlowTypes API raw response:', data);

        // Convert enum numbers to movement objects
        const flowTypes: MiscFlowType[] = (data.flowTypes || [])
            .map((flowType: number | MiscFlowType) => {
                // If it's already an object with name/label, return as is
                if (typeof flowType === 'object' && flowType.name && flowType.label) {
                    return flowType;
                }
                // If it's a number (enum), convert to movement object
                if (typeof flowType === 'number') {
                    return flowDirectionToMovement[flowType] || null;
                }
                return null;
            })
            .filter((item: MiscFlowType | null): item is MiscFlowType => item !== null);

        const result = { hasAccess: data.hasAccess ?? true, flowTypes };
        console.log('miscFlowTypes API transformed response:', result);
        return result;
    } catch (error) {
        console.error('fetchMiscFlowTypes error:', error);
        throw error;
    }
};
